module.exports = __webpack_public_path__ + "static/media/sequencing-dog-grey.a05e5d61.svg";